import { z } from "zod/v4";
/** string型の数値表現も扱えるようにするスキーマ */
const NumberString = z
    .string()
    .refine((val) => !isNaN(Number(val)) && val.trim() !== "", {
    error: "数値形式の文字列である必要があります",
})
    .transform((val) => Number(val));
const StringifyNumberSchema = z.number().or(NumberString).pipe(z.number());
export const StringifyNumber = {
    schema: StringifyNumberSchema,
};
//# sourceMappingURL=stringify-number.js.map